// Ashmark stylized "A" monogram — sweeping flourish on the left leg.
export function Monogram({ className = "", stroke = "currentColor" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} fill="none" aria-hidden="true">
      {/* right leg */}
      <path d="M50 14 L78 86" stroke={stroke} strokeWidth="5" strokeLinecap="round" />
      {/* left leg with flourish sweeping outward at the base */}
      <path
        d="M50 14 L28 72 C24 84 14 88 6 82"
        stroke={stroke}
        strokeWidth="5"
        strokeLinecap="round"
      />
      {/* crossbar */}
      <path d="M33 60 L67 60" stroke={stroke} strokeWidth="4.5" strokeLinecap="round" />
    </svg>
  );
}

export function Logo({ className = "", color = "#1e1d1c", sub = "#a4946c" }) {
  return (
    <div className={`flex flex-col items-start leading-none ${className}`}>
      <span
        className="font-serif lowercase tracking-tight"
        style={{ color, fontSize: "1.5rem", fontWeight: 600, lineHeight: 1 }}
      >
        ashmark
      </span>
      <span
        className="uppercase font-sans"
        style={{ color: sub, fontSize: "0.5rem", letterSpacing: "0.35em", marginTop: "2px" }}
      >
        Custom Woodwork
      </span>
    </div>
  );
}
